import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Button,
  Column,
  ComboBox,
  Grid,
  DataTable,
  Modal,
  Pagination,
  Select,
  SelectItem,
  TextInput,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Theme,
  Row,
} from '@carbon/react';

import { Add, Edit, TrashCan } from '@carbon/icons-react';


import {
  postUniqueExpenditure,
  getListMailNameEmployeeByKey,
  getCountriesList,
  getCommoditiesList,
  getResoucesForViews,
} from "../../services/services";
import { ThemeContext } from "../../context/ThemeProvider";
import SessionController from "../../components/FrontSessionController/SessionController";
import CommodityHeader from "../../components/Header";
import { useNavigate } from "react-router-dom";
import MessageModal from "../../components/MessageModal/MessageModal";

const headers = [
  {
    key: "codewithseparation",
    header: "CTRYCODE/COMPCODE/COMMCODE",
  },
  {
    key: "firstrange",
    header: "First Range",
  },
  {
    key: "approverFirst",
    header: "Approver First",
  },
  {
    key: "secondrange",
    header: "Second Range",
  },
  {
    key: "approverSecond",
    header: "Approver Second",
  },
  {
    key: "thirdrange",
    header: "Third Range",
  },
  {
    key: "approverThird",
    header: "Approver Third",
  },
  {
    key: "fourthrange",
    header: "Fourth Range",
  },
  {
    key: "approverFourth",
    header: "Approver Fourth",
  },
  {
    key: "fifthrange",
    header: "Fifth Range",
  },
  {
    key: "approverFifth",
    header: "Approver Fifth",
  },
  {
    key: "creationDate",
    header: "Creation Date",
  },
  {
    key: "createBy",
    header: "Created By",
  },
];

const UniqueExpenditure = () => {

  const EMPLOYEE_LIST_SEARCH_INPUT = [
    {
      mail: 'Please enter 4 or more characters',
      disabled: true

    }
  ]
  const EMPLOYEE_LIST_IS_EMPTY =
  [
    {
      mail: 'Not result found',
      disabled: true
    }
  ];

  const REGEX_ONLY_NUMBER_AND_DOT = /[^0-9.]/g;

  const navigate = useNavigate();
  const theme = useContext(ThemeContext);
  const user = theme.theme.email;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [messageModal, setMessageModal] = useState("");
  const [messageSessionLost, setMessageSessionLost] = useState("");

  const [listEmployeesForUnique, setListEmployeesForUnique] = useState(EMPLOYEE_LIST_SEARCH_INPUT);  

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page);
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize);
    }
  };

  const isRequestActive = (enable) => {
    if (enable) {
      if (processingRequest.current) {
        openMessageModal("The request is processing");
        return true;
      }
      document.body.className = "waiting";
      processingRequest.current = enable;
      return false;
    } else {
      processingRequest.current = enable;
      document.body.className = "";
    }
    return false;
  };

  const openMessageModal = (response) => {
    let newMessageResponse = [
      messageResponse.current,
      <br />,
      <br />,
      response,
    ];
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  };

  const closeMessageModal = () => {
    setMessageModal(false);
    messageResponse.current = [];
  };

  function createOptionRange(numb) {
    const numOptions = staticRange;
    const options = Array.from({ length: numOptions }, (_, index) => ({
      value: `${index + 1}`,
      label: `${index + 1}`,
    }));
    return options;
  }

  const [fullRow, setFullRow] = useState({});

  const [lastCountryChosen, setLastCountryChosen] = useState();

  const [countryList, setCountryList] = useState([]);
  const [commodityList, setCommodityList] = useState([]);

  const [rowRangeData, setRowRangeData] = useState({});
  const [rowCodeData, setRowCodeData] = useState({});
  const [rowCountryData, setRowCountryData] = useState({});
  const [rowCountryApproverData, setRowCountryApproverData] = useState({});
  const [rowApproverData, setRowApproverData] = useState('');
  const [rowApproverDataAlreadySelected, setRowApproverDataAlreadySelected] = useState('');
  const [rowMinimumData, setRowMinimumData] = useState({});
  const [rowMaximumData, setRowMaximumData] = useState({});
  const [removeUniqueModal, setRemoveUniqueModal] = useState(false);
  const [rowUniqueToRemove, setRowUniqueToRemove] = useState({});

  const [rows, setRows] = useState([]);

  const [addUniqueRangeModal, setAddUniqueRangeModal] = useState(false);
  const [findApproverModal, setFindApproverModal] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [isNewRange, setIsNewRange] = useState(false);
  const [staticRange, setStaticRange] = useState();
  const messageResponse = useRef([]);
  const processingRequest = useRef(false);

  const rangeoptions = createOptionRange(staticRange);
  const allRows = rows;  

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      // Collect all arguments passed to the debounced function
      clearTimeout(timeout); // Clear any existing timeout
      timeout = setTimeout(() => {
        func.apply(this, args); // Execute the original function with the correct context and arguments
      }, delay);
    };
  }

  const processRemoveUnique = (row) => {
    setRemoveUniqueModal(true);
    setRowUniqueToRemove(row);
  }

  const closeRemoveUnique = () => {
    setRemoveUniqueModal(false);
  }

  const getEmployeeList = (inputText) => {
    if (!isSearchInputForEmployeeValid(inputText)) return;
    inputText = inputText.toLowerCase();
    let request = {};
    request.clave = inputText;
    getListMailNameEmployeeByKey(request)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((response) => {
          processResponseForEmployeeSearch(response);
        });
      } else if (response.status === 410) {
        response.text().then((res) => {
          setMessageSessionLost(res);
        });
      }else if(response.status === 500){
        console.log(response.status);
        //do nothing
      }else{
        response.text()
          .then(response => {            
            openMessageModal(response);
        })
      }
    })
    .catch((error) => {
      console.log(error)
    });
  };
  
  const isSearchInputForEmployeeValid = (inputText) => {        
    if(inputText === undefined || inputText.length < 4){      
      setListEmployeesForUnique(EMPLOYEE_LIST_SEARCH_INPUT);      
      return false;;
    }
    return true;
  }

  const debouncedGetEmployeeList = debounce(getEmployeeList, 300);

  const processResponseForEmployeeSearch = (response) => {    
    setListEmployeesForUnique(EMPLOYEE_LIST_IS_EMPTY)
    if(response.length != 0){
      setListEmployeesForUnique(response);
    }    
  }

  function EditSelectedRow(row) {
    setRowRangeData(1);
    setStaticRange(verifyRange(row));
    setRowCodeData(row.cells[0].value);
    var code = row.cells[0].value;
    var country = code.substring(0, 3);
    setRowCountryData(country);
    setRowCountryApproverData(country);
    if (lastCountryChosen !== "613") {      
      getCommodities(country);
    }
    setFullRow(row);
    //setRowApproverDataAlreadySelected(row.cells[2].value);    
    var firstrange = row.cells[1].value;
    var minimum = firstrange.substring(0, firstrange.indexOf(" "));
    var maximum = firstrange.substring(
      firstrange.indexOf(" ") + 1,
      firstrange.length
    );
    setRowMinimumData(minimum);
    setRowMaximumData(maximum);
    setLastCountryChosen(country);
    ActionUniqueModal("add3");
  }
  // function that throws an error

  function hasFiveRange(row) {
    if (row.cells[10].value === "" || row.cells[10].value === undefined) {
      return false;
    } else {
      return true;
    }
  }

  const goHomeScreen = () => {
    navigate("/home");
  };

  function AddNewRange(row) {
    setStaticRange(verifyRange(row) + 1);
    setIsNewRange(true);
    ActionUniqueModal("addNewRange", row);
  }

  function verifyRange(row) {
    if (row.cells[9].value !== "0 0") {
      return 5;
    } else if (row.cells[7].value !== "0 0") {
      return 4;
    } else if (row.cells[5].value !== "0 0") {
      return 3;
    } else if (row.cells[3].value !== "0 0") {
      return 2;
    } else {
      return 1;
    }
  }

  function obtainBodyRequest() {
    return rows.map((row) =>
      Object.keys(row)
        .filter((key) => key !== "code")
        .reduce((obj, key) => {
          obj[key] = row[key];
          return obj;
        }, {})
    );
  }

  function addUniqueExp() {
    let key = rowCodeData;
      
    const bodyRequest = obtainBodyRequest();

    const fullbody = {
      clave: key,
      tipo:'add',
      rango: rowRangeData,
      from: rowMinimumData,
      to: rowMaximumData,
      approver: rowApproverData,      
    };
    submitUniqueExpenditure(fullbody);
    
  } 

  const fieldsAreValid = (body) => {
    if(body.clave.length === 0 || body.rango.length === 0 ||
       body.from.length === 0 || body.to.length === 0 || 
       body.approver.length === 0){
        openMessageModal("Fields can not be left empty");
        return false;
       }
    return true;
  }

  const submitUniqueExpenditure = async (body) => {
    if(!fieldsAreValid(body)){
      return;
    }
    if(isRequestActive(true)){
      return;
    } 
    await postUniqueExpenditure(body)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((response) => {                    
          openMessageModal("The Request was Successful");                      
          setUniqueList(response);
        });
      } else if (response.status === 410) {
        response.text().then((res) => {
          setMessageSessionLost(res);
        });
      } else {
        response.text()
        .then(response => {
          openMessageModal(response);
        })
      }
    });
    ActionUniqueModal("close");    
    closeRemoveUnique();
    isRequestActive(false);
  }

  function editUniqueExp() {        
    let key = rowCodeData;
    const bodyRequest = obtainBodyRequest();
    const fullbody = {
      clave: key,
      tipo:'update',
      rango: rowRangeData,
      from: rowMinimumData,
      to: rowMaximumData,
      approver: rowApproverData,            
    };
    submitUniqueExpenditure(fullbody);    
  }

  function removeUniqueExp() {
    
    let fromTo = rowUniqueToRemove.cells[1].value.split(" ");
    let from = fromTo[0];
    let to = fromTo[1];
    let rango = 1;
    let approver = rowUniqueToRemove.cells[2].value;
    
    setRowCodeData(rowUniqueToRemove.cells[0].value);    
    let key = rowUniqueToRemove.cells[0].value
    const bodyRequest = obtainBodyRequest();

    console.log(bodyRequest);
    const fullbody = {
      tipo: "remove",
      clave: key,
      rango: rango.toString(),
      approver: approver,
      from: from.toString(),
      to: to.toString(),
    };
    submitUniqueExpenditure(fullbody);
    
  }

  const getCountries = async () =>
    await getCountriesList().then((response) => {
      if (response.status === 200) {
        response.json().then((response) => {
          response.sort((a, b) => a.countryName.localeCompare(b.countryName));
          setCountryList(response);
        });
      } else if (response.status === 410) {
        response.text().then((res) => {
          setMessageSessionLost(res);
        });
      }
    });

  const getUniqueList = async (request) =>
    await getResoucesForViews(request).then((response) => {
      if (response.status === 200) {
        response.json().then((response) => {
          setUniqueList(response);
        });
      } else if (response.status === 410) {
        response.text().then((res) => {
          setMessageSessionLost(res);
        });
      }
    });

  const setUniqueList = (response) => {
    response.map((row, id) => {
      row.id = id;
      row.from = row.firstMinAmount;
      row.to = row.firstMaxAmount;
      row.rango = row.firstMaxAmount - row.firstMinAmount;
      row.codewithseparation =
        row.key.ctrycode + "-" + row.key.compcode + "-" + row.key.commodity;
      row.code = row.key.ctrycode + row.key.compcode + row.key.commodity;
    });
    setRows(response);
  };

  const getCommodities = async (ctrycode) => {
    let request = {};
    request.pais = ctrycode;
    document.body.className = 'waiting';
    await getCommoditiesList(request)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((response) => {
          setCommodityList(response);
        });
      } else if (response.status === 410) {
        response.text().then((res) => {
          setMessageSessionLost(res);
        });
      }
    });    
    document.body.className = '';
  }

  const processSelectEmployeeToUnique = (e) => {
    let employeeSelected = "";
    if (e.selectedItem != undefined) {
      employeeSelected = e.selectedItem.mail;
    }
    setRowApproverData(employeeSelected);
  };

  function ActionUniqueModal(action, row) {
    if (action === "add") {
      setRowRangeData(1);
      setIsEdit(false);
      setIsNewRange(false);
      setRowApproverData('');
      setRowApproverDataAlreadySelected('');
      setListEmployeesForUnique(EMPLOYEE_LIST_SEARCH_INPUT)
      setAddUniqueRangeModal(true);
    } else if (action === "close") {
      setRowApproverDataAlreadySelected(rowApproverData);
      setAddUniqueRangeModal(false);
      setFindApproverModal(false);
      setIsEdit(false);
    } else if (action === "addNewRange") {
      setRowRangeData(verifyRange(row) + 1)
      setAddUniqueRangeModal(false);
      setRowCodeData(row.cells[0].value);
      setRowCountryData(row.cells[0].value.substring(0, 3));
      setRowApproverData('');
      setRowApproverDataAlreadySelected('');
      setListEmployeesForUnique(EMPLOYEE_LIST_SEARCH_INPUT)
      setRowMinimumData("");
      setRowMaximumData("");
      setFindApproverModal(true);
    } else if (action === "addNewComm") {
      setAddUniqueRangeModal(false);
      setStaticRange(1);
      setRowCodeData("");
      setRowCountryData("");
      setRowApproverData('');
      setRowApproverDataAlreadySelected('');
      setListEmployeesForUnique(EMPLOYEE_LIST_SEARCH_INPUT)
      setRowMinimumData("");
      setRowMaximumData("");
      setFindApproverModal(true);
    } else if (action === "edit") {
      EditSelectedRow(row);
    } else if (action === "add3") {
      setIsEdit(true);
      setAddUniqueRangeModal(false);
      setFindApproverModal(true);
    } else if (action === "submit") {
      if (isEdit || isNewRange) {
        //modifica
        editUniqueExp();      
      } else {
        addUniqueExp();
      }
    }
  }

  const handleTypeSelect = (e, row) => {
    const type = e.target.id;
    if (type.includes("range")) {
      var range = e.target.value;
      setRowRangeData(e.target.value);
      var minimum = "";
      var maximum = "";
      var info = "";
      var approver = "";
      if (range === "5") {
        info = fullRow.cells[9].value;
        minimum = info.substring(0, info.indexOf(" "));
        maximum = info.substring(info.indexOf(" ") + 1, info.length);
        approver = fullRow.cells[10].value;
      } else if (range === "4") {
        info = fullRow.cells[7].value;
        minimum = info.substring(0, info.indexOf(" "));
        maximum = info.substring(info.indexOf(" ") + 1, info.length);
        approver = fullRow.cells[8].value;
      } else if (range === "3") {
        info = fullRow.cells[5].value;
        minimum = info.substring(0, info.indexOf(" "));
        maximum = info.substring(info.indexOf(" ") + 1, info.length);
        approver = fullRow.cells[6].value;
      } else if (range === "2") {
        info = fullRow.cells[3].value;
        minimum = info.substring(0, info.indexOf(" "));
        maximum = info.substring(info.indexOf(" ") + 1, info.length);
        approver = fullRow.cells[4].value;
      } else if (range === "1") {
        info = fullRow.cells[1].value;
        minimum = info.substring(0, info.indexOf(" "));
        maximum = info.substring(info.indexOf(" ") + 1, info.length);
        approver = fullRow.cells[2].value;
      }
      setRowMinimumData(minimum);
      setRowMaximumData(maximum);
      setRowApproverData(approver);
    } else if (type.includes("country")) {
      setRowCountryData(e.target.value);
      getCommodities(e.target.value);
    } else if (type.includes("code")) {
      if (!isEdit && !isNewRange) {
        setRowCodeData(e.target.value);
      }
    } else if (type.includes("minimum")) {
      setOnlyNumbers(e);
      setRowMinimumData(e.target.value);
    } else if (type.includes("maximum")) {
      setOnlyNumbers(e);
      setRowMaximumData(e.target.value);
    }
  };

  function loadRangeCell(row, cell, rowIndex, cellIndex) {
    if (cellIndex === 1) {
      row.cells[cellIndex].value =
        allRows[rowIndex].firstMinAmount +
        " " +
        allRows[rowIndex].firstMaxAmount;
      return (
        <TableCell key={cell.id}>
          From: {allRows[rowIndex].firstMinAmount} <br></br>To: <br></br>
          {allRows[rowIndex].firstMaxAmount}
        </TableCell>
      );
    } else if (
      cellIndex === 3 &&
      allRows[rowIndex].secondMinAmount !== undefined
    ) {
      row.cells[cellIndex].value =
        allRows[rowIndex].secondMinAmount +
        " " +
        allRows[rowIndex].secondMaxAmount;
      return (
        <TableCell key={cell.id}>
          From: {allRows[rowIndex].secondMinAmount} <br></br>To: <br></br>
          {allRows[rowIndex].secondMaxAmount}
        </TableCell>
      );
    } else if (
      cellIndex === 5 &&
      allRows[rowIndex].thirdMinAmount !== undefined
    ) {
      row.cells[cellIndex].value =
        allRows[rowIndex].thirdMinAmount +
        " " +
        allRows[rowIndex].thirdMaxAmount;
      return (
        <TableCell key={cell.id}>
          From: {allRows[rowIndex].thirdMinAmount} <br></br>To: <br></br>
          {allRows[rowIndex].thirdMaxAmount}
        </TableCell>
      );
    } else if (
      cellIndex === 7 &&
      allRows[rowIndex].fourthMinAmount !== undefined
    ) {
      row.cells[cellIndex].value =
        allRows[rowIndex].fourthMinAmount +
        " " +
        allRows[rowIndex].fourthMaxAmount;
      return (
        <TableCell key={cell.id}>
          From: {allRows[rowIndex].fourthMinAmount} <br></br>To: <br></br>
          {allRows[rowIndex].fourthMaxAmount}
        </TableCell>
      );
    } else if (
      cellIndex === 9 &&
      allRows[rowIndex].fifthMinAmount !== undefined
    ) {
      row.cells[cellIndex].value =
        allRows[rowIndex].fifthMinAmount +
        " " +
        allRows[rowIndex].fifthMaxAmount;
      return (
        <TableCell key={cell.id}>
          From: {allRows[rowIndex].fifthMinAmount} <br></br>To: <br></br>
          {allRows[rowIndex].fifthMaxAmount}
        </TableCell>
      );
    } else {
      return <TableCell key={cell.id}>{cell.value}</TableCell>;
    }
  }

  const setOnlyNumbers = (input) => {
    input.target.value = input.target.value.replace(REGEX_ONLY_NUMBER_AND_DOT,'')          
  }
  
  const setDefaultCeroValue = (input) => {
    setOnlyNumbers(input)
    if(input.target.value === ''){
      input.target.value = '0';
    }            
  }

  useEffect(() => {
    getCountries();
    getCommodities("613");
    let request = {};
    request.viewName = "unique";
    getUniqueList(request);
    setLastCountryChosen("613");
  }, []);

  return (
    <>
      <Theme theme="g90">
        <CommodityHeader />
      </Theme>
      <h2 className="table-title">Unique Expenditure</h2>
      <Grid>
        <Theme theme="g90">
          <CommodityHeader />
        </Theme>
        <Modal
          className="addUnique-modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="New Commodity/Add Range modal"
          modalAriaLabel=""
          onBlur={function noRefCheck() {}}
          onClick={function noRefCheck() {}}
          onFocus={function noRefCheck() {}}
          onKeyDown={function noRefCheck() {}}
          onRequestClose={() => ActionUniqueModal("close")}
          onRequestSubmit={() => ActionUniqueModal("addNewComm")}
          onSecondarySubmit={() => ActionUniqueModal("close")}
          open={addUniqueRangeModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Ok"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={
            <p>
              <strong>Please, confirm:</strong>
            </p>
          }
        >
          <div>
            <p>
              This action will <strong>add</strong> a new commodity to the table below.
            </p>
          </div>
        </Modal>
        <Modal
          className="removeUniqueConfirm-modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Remove unique expenditure"
          modalAriaLabel=""
          onBlur={function noRefCheck() {}}
          onClick={function noRefCheck() {}}
          onFocus={function noRefCheck() {}}
          onKeyDown={function noRefCheck() {}}
          onRequestClose={() => closeRemoveUnique()}
          onRequestSubmit={() => removeUniqueExp()}
          onSecondarySubmit={() => closeRemoveUnique("close")}
          open={removeUniqueModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Ok"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={
            <p>
              <strong>Please, confirm:</strong>
            </p>
          }
        >
          <div>
            <p>
              This action will <strong>remove</strong> the selected register.
            </p>
          </div>
        </Modal>
        <Modal
          className="addUniqueRange-modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Find Approver modal"
          modalAriaLabel="Find Approver modal"
          onBlur={function noRefCheck() {}}
          onClick={function noRefCheck() {}}
          onFocus={function noRefCheck() {}}
          onKeyDown={function noRefCheck() {}}
          onRequestClose={() => ActionUniqueModal("close")}
          onRequestSubmit={() => ActionUniqueModal("submit")}
          onSecondarySubmit={() => ActionUniqueModal("close")}
          open={findApproverModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Submit"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={
            <p>
              <strong>
                Asterisks (<h5 className="asterisc">*</h5>) indicate fields
                required to complete this transaction.
              </strong>
            </p>
          }
        >
          <Grid className="column-addRange">
            <Column lg={16}>
              <Row className={"text-test"}>
                <Column className="column-asterisc" lg={6}>
                  <h5>
                    RANGE<h5 className="asterisc">*</h5>:
                  </h5>
                </Column>
                {isEdit ? (
                  <Select
                    className="style-select"
                    id="range"
                    labelText=""
                    defaultValue={1}
                    value={rowRangeData}
                    onChange={(e) => handleTypeSelect(e)}
                  >
                    {rangeoptions.map((option) => (
                      <SelectItem
                        key={option.value}
                        text={option.label}
                        value={option.value}
                      >
                        {option.label}
                      </SelectItem>
                    ))}
                  </Select>
                ) : !isNewRange ? (
                  <p id="range" className="text-range">
                    1
                  </p>
                ) : (
                  <p id="range" className="text-range">
                    {staticRange}
                  </p>
                )}
              </Row>
              <Row className={"text-test"}>
                <Column className="column-asterisc" lg={6}>
                  <h5 className="text-unique">
                    COUNTRY<h5 className="asterisc">*</h5>:{" "}
                  </h5>
                </Column>
                <>
                  {" "}
                  {isEdit || isNewRange ? (
                    <>
                      <Select
                        className="style-select"
                        labelText=""
                        defaultValue={rowCountryData}
                        value={rowCountryData}
                        id="country"
                        onChange={(e) => handleTypeSelect(e)}
                        disabled
                      >
                        {countryList.map((country) => (
                          <SelectItem
                            disabled
                            value={country.countryCode}
                            text={country.countryName}
                          />
                        ))}
                      </Select>
                    </>
                  ) : (
                    <>
                      <Select
                        className="style-select"
                        labelText=""
                        defaultValue={rowCountryData}
                        value={rowCountryData}
                        id="country"
                        onChange={(e) => handleTypeSelect(e)}
                      >
                        <SelectItem label="Select country" />
                        {countryList != [] &&
                          countryList.map((country) => (
                            <SelectItem
                              value={country.countryCode}
                              text={country.countryName}
                            />
                          ))}
                      </Select>
                    </>
                  )}
                </>
              </Row>

              <Row className={"text-test"}>
                <Column className="column-asterisc" lg={6}>
                  <h5 className="text-unique">
                    CTRY, COMP, COMM CODE<h5 className="asterisc">*</h5>:{" "}
                  </h5>
                </Column>
                <>
                  {" "}
                  {isEdit || isNewRange ? (
                    <>
                      <Select
                        className="style-select"
                        labelText=""
                        defaultValue={rowCodeData}
                        value={rowCodeData}
                        id="code"
                        onChange={(e) => handleTypeSelect(e)}
                      >
                        <SelectItem label="Select code" />
                        {commodityList.map((comm) => (
                          <SelectItem
                            disabled
                            value={
                              comm.ctrycode +
                              "-" +
                              comm.compcode +
                              "-" +
                              comm.commcode
                            }
                            text={
                              comm.ctrycode +
                              "-" +
                              comm.compcode +
                              "-" +
                              comm.commcode
                            }
                          />
                        ))}
                      </Select>
                    </>
                  ) : (
                    <>
                      <Select
                        className="style-select"
                        labelText=""
                        defaultValue={rowCodeData}
                        value={rowCodeData}
                        id="code"
                        onChange={(e) => handleTypeSelect(e)}
                      >
                        <SelectItem label="Select code" />
                        {commodityList &&
                          commodityList.map((comm) => (
                            <SelectItem
                              value={
                                comm.ctrycode +
                                "-" +
                                comm.compcode +
                                "-" +
                                comm.commcode
                              }
                              text={
                                comm.ctrycode +
                                "-" +
                                comm.compcode +
                                "-" +
                                comm.commcode
                              }
                            />
                          ))}
                      </Select>
                    </>
                  )}
                </>
              </Row>
              <Row className={"text-test"} key={"keyRowForUniqueApprover"}>
                <Column className="column-asterisc" lg={6}>
                  <h5 className="text-unique">
                    APPROVER
                    <h6 className="asterisc">*</h6>:
                  </h5>
                </Column>          
                <ComboBox
                  className="style-select-delegation"
                  onChange={(input) => {
                    processSelectEmployeeToUnique(input);
                  }}                  
                  id="idComboBoxEmployeeToUnique"
                  placeholder="Search Approver"
                  key={'keyComboBoxEmployeeToUnique'}        
                  items={listEmployeesForUnique}    
                  selectedItem={rowApproverDataAlreadySelected}                                      
                  titleText=""
                  helperText=""
                  itemToString={(item) => (item ? item.mail : "")}
                  onInputChange={(inputText) =>
                    debouncedGetEmployeeList(
                      inputText
                    )
                  }
                />
              </Row>
              <Row className={"text-test"}>
                <Column className="column-asterisc" lg={6}>
                  <h5 className="text-unique">
                    FROM<h5 className="asterisc">*</h5>:
                  </h5>
                </Column>
                <TextInput
                  className="style-input"
                  id="text-minimum-amount"
                  onKeyUp={(e) => setOnlyNumbers(e)}
                  onBlur={(e) => setDefaultCeroValue(e)}
                  onChange={(e) => handleTypeSelect(e)}
                  placeholder="Insert a minimum amount"
                  value={rowMinimumData}
                />
              </Row>
              <Row className={"text-test"}>
                <Column className="column-asterisc" lg={6}>
                  <h5 className="text-unique">
                    TO<h5 className="asterisc">*</h5>:
                  </h5>
                </Column>
                <TextInput
                  className="style-input"
                  id="text-maximum-amount"
                  onKeyUp={(e) => setOnlyNumbers(e)}
                  onBlur={(e) => setDefaultCeroValue(e)}
                  onChange={(e) => handleTypeSelect(e)}
                  placeholder="Insert a maximum amount"
                  value={rowMaximumData}
                />
              </Row>
            </Column>
            <Column lg={6}></Column>
          </Grid>
        </Modal>
      </Grid>

      <Grid>
        <Column lg={16}>
          <Button className="style-bttbackID" size="lg" onClick={goHomeScreen}>
            Back to Home
          </Button>
          <Button
            className="style-bttAddCommRange"
            onClick={() => ActionUniqueModal("add")}
            size="lg"
          >
            Add New Commodity
          </Button>
          <DataTable
            rows={rows}
            headers={headers}
            radio
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              getSelectionProps,
              onInputChange,
            }) => (
              <TableContainer>
                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch
                      persistent
                      size="sm"
                      onChange={onInputChange}
                    />
                  </TableToolbarContent>
                </TableToolbar>
                <Table useZebraStyles>
                  <TableHead>
                    <TableRow>
                      <TableHeader className="style-header-actions">
                        Add&nbsp;Range/Edit/Remove
                      </TableHeader>

                      {headers.map((header) => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows != [] &&
                      rows
                        .slice((page - 1) * pageSize)
                        .slice(0, pageSize)
                        .map((row, rowIndex) => (
                          <TableRow key={rowIndex} {...getRowProps({ row })}>
                            <TableCell className="style-cell-buttons">
                              {hasFiveRange(row) ? (
                                <Button
                                  className="style-action-buttons"
                                  kind="ghost"
                                  renderIcon={Add}
                                  size="sm"
                                  disabled
                                  title="This unique expenditure has already five ranges"
                                ></Button>
                              ) : (
                                <Button
                                  className="style-action-buttons"
                                  onClick={() => AddNewRange(row)}
                                  kind="ghost"
                                  renderIcon={Add}
                                  size="sm"
                                  title="Add new range"
                                ></Button>
                              )}
                              <Button
                                className="style-action-buttons"
                                onClick={() => EditSelectedRow(row)}
                                kind="ghost"
                                renderIcon={Edit}
                                size="sm"
                                title="Modify this row"
                              ></Button>
                              <Button
                                className="style-action-buttons"
                                onClick={() => processRemoveUnique(row)}
                                kind="danger--ghost"
                                renderIcon={TrashCan}
                                size="sm"
                                title="Remove this row"
                              ></Button>
                            </TableCell>
                            {row.cells.map((cell, i) => (
                              <>
                                {i === 1 ||
                                i === 3 ||
                                i === 5 ||
                                i === 7 ||
                                i === 9 ? (
                                  loadRangeCell(row, cell, rowIndex, i)
                                ) : (
                                  <TableCell key={cell.id}>
                                    {cell.value}
                                  </TableCell>
                                )}
                              </>
                            ))}
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>

                <Pagination
                  onChange={changePaginationState}
                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[10, 25, 50, 100]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />
        </Column>
        <SessionController messageLostSessionCallback={messageSessionLost} />
        <MessageModal
          messageCallback={messageResponse.current}
          messageModalCallback={messageModal}
          closeMessageModalCallback={closeMessageModal}
        />
      </Grid>
    </>
  );
};

export default UniqueExpenditure;
